import { OpenDialogAddEditLicenceComponent } from './../../dialog/open-dialog-add-edit-licence/open-dialog-add-edit-licence.component';
import { FederationsService } from './../../../shared/services/federations/federations.service';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { OpenDialogAddEditFederationComponent } from 'app/components/dialog/open-dialog-add-edit-federation/open-dialog-add-edit-federation.component';
import { DatatableBaseComponent } from 'app/shared/components/datatable-base.component';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { Federation, Licence } from 'app/shared/models/class/federation/federation';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-admin-federations',
  templateUrl: './admin-federations.component.html',
  styleUrls: ['./admin-federations.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ])
  ]
})
export class AdminFederationsComponent extends DatatableBaseComponent implements OnInit {

  clubCode: any;
  title: string;

  federations: Federation[] = [];
  dataSource: MatTableDataSource<any>;

  displayedColumns = ['label', 'description', 'actions'];

  isLoading = false;


  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';

  searchForm: UntypedFormGroup;
  valueInput: string;

  expandedElement: null;
  idExpanded = null;

  constructor(
    protected uiSrv: UiService,
    private formBuilder: UntypedFormBuilder,
    private faIconService: FaiconService,
    private tooltipSrv: TooltipService,
    private dialog: MatDialog,
    private federationsSrv: FederationsService
  ) {
    super(uiSrv);
  }

  ngOnInit(): void {
    this.initComponent();
  }

  private async initComponent() {

    this.title = 'Liste des fédérations et des licences';

    this.isLoading = true;
    this.initForm();
    this.initSubscriptions();
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

  private initSubscriptions(): void {

    this.addSubscription(
      this.federationsSrv.federationsListChanged.subscribe(federationsFromSrv => {
        this.isLoading = false;
        this.federations = federationsFromSrv;
        this.initTable();
      })
    );

    this.addSubscription(
      this.federationsSrv.getFederations().subscribe((federationsFromSrv => {
        this.federations = federationsFromSrv;
      }))
    );

  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.federations);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.length = this.federations.length;
    this.isLoading = false;
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  getTooltip(value: string): string {
    return this.tooltipSrv.getTooltip(value);
  }

  applyFilter(filterValue): void {
    this.valueInput = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.valueInput = '';
    this.applyFilter(this.valueInput);
  }

  openDialogAddFederation(actionDialog: string, federationUpdate?: Federation): void {

    const dialogRef = this.dialog.open(OpenDialogAddEditFederationComponent, {
      data: { action: actionDialog, federation: federationUpdate || null },
      height: '300px',
      width: '600px'
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {res ? this.getFederations(): null}
    });
  }

  openDialogAddLicence(actionDialog: string, federation: Federation, licenceUpdate?: Licence): void {

    const dialogRef = this.dialog.open(OpenDialogAddEditLicenceComponent, {
      data: { action: actionDialog, federation: federation, licence: licenceUpdate || null },
      height: '300px',
      width: '600px'
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {res ? this.getFederations(): null}
    });
  }

  getFederations() {
    this.federationsSrv.getFederations().subscribe();
  }

  expandRow(elementSelected, event: Event): void {
    event.stopPropagation();
    this.idExpanded = elementSelected.federationKey;

    if (this.expandedElement === elementSelected) {
      this.expandedElement = null;
      this.idExpanded = null;
    } else {

      this.expandedElement = elementSelected;
    }
  }

}
